import { createRoot } from 'react-dom/client';
import { App } from './ui/App';
import { ClassSheet, ModuleSheet, VariantSheet } from './ui/ClassSheet';
import { OgSheet } from './ui/OgSheet';
import { CosmeticSheet } from './ui/CosmeticSheet';
import { PassSheet } from './ui/PassSheet';
import { RenderSheet } from './ui/RenderSheet';
import { detectLang, isLang, setLang } from './i18n';
import { getSettings, onSettings } from './game/settings';
import './ui/styles.css';
import './ui/menu.css';
import './ui/store.css';
import './ui/hud.css';
import './ui/legal.css';
import './ui/paint.css';
import './ui/forge.css';
import './ui/admin.css';

const saved = getSettings().lang;
void setLang(isLang(saved) ? saved : detectLang());
// Taille des textes, contraste et animations réduites : appliqués à toute l'interface, en direct.
const applyA11y = (s = getSettings()) => {
  const root = document.documentElement;
  root.style.setProperty('--ui-scale', String(s.uiScale));
  if (s.highContrast) root.dataset.contrast = 'high';
  else delete root.dataset.contrast;
  if (s.reducedMotion) root.dataset.motion = 'reduced';
  else delete root.dataset.motion;
};
applyA11y();
onSettings(applyA11y);
const sheet = new URLSearchParams(location.search).get('sheet');
const family = new URLSearchParams(location.search).get('family') ?? 'C01';
createRoot(document.getElementById('root')!).render(
  sheet === 'classes' ? <ClassSheet /> : sheet === 'variants' ? <VariantSheet family={family} /> : sheet === 'og' ? <OgSheet /> : sheet === 'cosmetics' ? <CosmeticSheet /> : sheet === 'pass' ? <PassSheet /> : sheet === 'rendu' ? <RenderSheet /> : sheet === 'modules' ? <ModuleSheet /> : <App />,
);
